import {
    ORDERLOADING,
    ORDERSUCCESS,
    ORDERERROR,
    ORDERFAILED,
    ORDERRESET,
    USERDATAUPDATE
} from "../actionTypes";

import { ToLocalStorage } from "../../utils/localStorage";
import { isMarketClosed } from "./marketActions";
import { server_url } from "../axios";


export const ordersuccess = $=> {
    
    return {
        type: ORDERSUCCESS,
    }
}
export const orderreset = $ => {
    return {
        type: ORDERRESET
    }
}
export const ordererror = (err) => {
    return {
        type: ORDERERROR,
        payload: err
    }
}
export const orderloading = $ => {
    return {
        type: ORDERLOADING
    }
}
export const orderfailed = payload => {
    return {
        type: ORDERFAILED,
        payload: payload
    }
}
export const userdataupdate = payload => {
    return {
        type: USERDATAUPDATE,
        payload: payload
    }
}




 

export const buyTrade = payload => async dispatch => {
     dispatch(orderloading())
    try {
         const marketClose  = await isMarketClosed();
         if(marketClose){
             return dispatch(orderfailed("Market Closed"))
         }
         await server_url.post('order/buy', {
                ...payload
            })
            .then(res => {
                ToLocalStorage("user", res.data.user);
                dispatch(ordersuccess());
                dispatch(userdataupdate(res.data.user));

    
            })
    } catch (e) {
        dispatch(orderfailed(e.response.data.message))
    };
}


export const sellTrade = payload => async dispatch => {
    dispatch(orderloading())
    try {
        const marketClose  = await isMarketClosed()
        if(marketClose){
            return dispatch(orderfailed("Market Closed"))
        }
        await server_url.post('order/sell', {
                ...payload
            })
            .then(res => {
                ToLocalStorage("user", res.data.user)
                dispatch(ordersuccess())
                dispatch(userdataupdate(res.data.user))
    
            })
    } catch (e) {
       dispatch(orderfailed(e.response.data.message))
    };
}

